import React, { useEffect, useState } from 'react'

import { useSelector } from 'react-redux'

import { BottomSheet } from '@interco/inter-ui/components/BottomSheet'
import { clearError } from '@store/ui/error/actions'
import { Text } from '@interco/inter-ui/components/Text'
import { Button } from '@interco/inter-ui/components/Button'
import { validaEnvHomeByBridge } from '@utils/functions'
import { ApplicationState } from '@store/types'
import { BridgeService } from '@services/bridge'
import Tag from '@utils/Tag'
import { trackingRefin } from '@store/refinanciamento/simulacao/actions'
import { StepRefin } from '@utils/enums'

import { connector, Props } from './types'
import { Header } from './styles'

const DEFAULT_TITLE = 'Estamos resolvendo um erro'
const DEFAULT_MESSAGE = 'Mas fique tranquilo, em breve você poderá continuar o seu processo.'
const DEFAULT_ACTION_TITLE = 'Tentar novamente'

const ErrorMessage = ({
  showError = false,
  title,
  message,
  actionTitle,
  shouldUseCustomTexts = false,
  actionCallback,
  block,
  dispatch,
  functionCallback,
  code,
}: Props) => {
  const [open, setOpen] = useState(showError)
  const { origemGoBack, isApp } = useSelector((state: ApplicationState) => state.ui.navigation)
  const displayedTitle = shouldUseCustomTexts && title ? title : DEFAULT_TITLE
  const displayedMessage = shouldUseCustomTexts && message ? message : DEFAULT_MESSAGE
  const displayedActionTitle =
    shouldUseCustomTexts && actionTitle ? actionTitle : DEFAULT_ACTION_TITLE

  useEffect(() => {
    dispatch(clearError())
  }, [dispatch])

  useEffect(() => {
    if (open) {
      dispatch(trackingRefin(code ?? StepRefin.ERRO))
      if (isApp) {
        Tag.enviarTagueamentoApp({
          screen: 'clt:refin:feedback',
          ref_type: '',
          content_action: 'Dado carregado',
          action_id: displayedTitle,
          section: 'feedback',
          sub_section: '',
          step: '',
          scenario: 'error',
          ref_figma: '2',
        })
      } else {
        Tag.enviarTagueamentoWeb({
          element_action: 'page_loaded',
          element_name: displayedTitle,
          c_page: window.location.href,
          redirect_url: '',
          section_name: 'payrollloan:refin:feedback',
          section: 'feedback',
          sub_section: '',
          step: '',
          scenario: 'error',
        })
      }
      BridgeService.tac({
        name: 'error-dialog',
        actions: [
          'buscar_contratos',
          'continuar_refinanciamento',
          'autorizar_termo_inss',
          'simular_condicao_oferta_seguro',
          'solicitar_contratacao',
          'criar_proposta',
          'buscar_documentos',
          'enviar_foto_documento',
          'solicitar_biometria',
          'confirmar_contratacao',
        ],
        isError: true,
      })
    }
  }, [open, isApp, dispatch, code, displayedTitle])

  useEffect(() => {
    setOpen(showError)
  }, [showError, setOpen])

  if (open) {
    return (
      <BottomSheet
        onClose={
          !block
            ? () => {
                setOpen(false)
                setTimeout(() => {
                  dispatch(clearError())
                }, 600)
              }
            : () => null
        }
      >
        <Header>
          <Text variant="headline-h3" color="typography" semiBold>
            {displayedTitle}
          </Text>
        </Header>
        <Text variant="body-3">{displayedMessage}</Text>

        {code !== StepRefin.ERRO_PROPOSTA_EM_ANDAMENTO && (
          <Button
            fullWidth
            style={{ marginTop: '16px' }}
            onClick={() => {
              if (isApp) {
                Tag.enviarTagueamentoApp({
                  screen: 'clt:refin:feedback',
                  ref_type: 'botao',
                  content_action: 'Toque',
                  action_id: displayedActionTitle,
                  section: 'feedback',
                  sub_section: '',
                  step: '',
                  scenario: 'error',
                  ref_figma: '2',
                })
              } else {
                Tag.enviarTagueamentoWeb({
                  element_action: 'click button',
                  element_name: displayedActionTitle,
                  c_page: window.location.href,
                  redirect_url: '',
                  section_name: 'payrollloan:refin:feedback',
                  section: 'feedback',
                  sub_section: '',
                  step: '',
                  scenario: 'error',
                })
              }
              setOpen(false)
              setTimeout(() => {
                dispatch(clearError())
                if (actionCallback instanceof Function) {
                  dispatch(actionCallback())
                } else if (functionCallback instanceof Function) {
                  functionCallback()
                }
              }, 600)
            }}
          >
            {displayedActionTitle}
          </Button>
        )}
        <Button
          fullWidth
          variant="secondary"
          style={{ marginTop: '16px' }}
          onClick={() => {
            if (isApp) {
              Tag.enviarTagueamentoApp({
                screen: 'clt:refin:feedback',
                ref_type: '',
                content_action: 'Toque',
                action_id: 'Voltar para home',
                section: 'feedback',
                sub_section: '',
                step: '',
                scenario: 'error',
                ref_figma: '2',
              })
            } else {
              Tag.enviarTagueamentoWeb({
                element_action: 'page_loaded',
                element_name: 'Voltar para home',
                c_page: window.location.href,
                redirect_url: '',
                section_name: 'payrollloan:refin:feedback',
                section: 'feedback',
                sub_section: '',
                step: '',
                scenario: 'error',
              })
            }
            setOpen(false)
            window.location.href = validaEnvHomeByBridge(String(origemGoBack), isApp) || ''
          }}
        >
          Voltar para home
        </Button>
      </BottomSheet>
    )
  }
  return <></>
}

export default connector(ErrorMessage)
